import { render, staticRenderFns } from "./FilesListVirtual.vue?vue&type=template&id=7164c6ec&scoped=true"
import script from "./FilesListVirtual.vue?vue&type=script&lang=ts"
export * from "./FilesListVirtual.vue?vue&type=script&lang=ts"
import style0 from "./FilesListVirtual.vue?vue&type=style&index=0&id=7164c6ec&prod&scoped=true&lang=scss"
import style1 from "./FilesListVirtual.vue?vue&type=style&index=1&id=7164c6ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7164c6ec",
  null
  
)

export default component.exports